import WaagChart from "./WaagChart";
import UserToDoList from "./UserToDoList";
import ClinicianHoursChart from "./ClinicianHoursChart";
export default function OwnerDashboardComponent() {
  return (
    <div className="grid grid-cols-3 gap-6 pb-20">
      <div className="col-span-3">
        <WaagChart />
        <ClinicianHoursChart />
        <UserToDoList />
      </div>
    </div>
  );
}
